import { BASE_API_URL } from 'helper/constant';
import { axiosPost } from '../axios/axios.config';
import axios from '../axios/axios.config';
import { store } from 'redux/store';
// ringerdev3@gmail.com/ringerdev2023 đây là account login portal dev nha anhdnt  @siphuzz

// siphuzz/password
// export const loginStepOne = async (data) => {
//   const response = await axios.get(
//     `http://35.224.7.3:8081/provider/token-with-authorities`,
//     {
//       password: 'password',
//       username: 'siphuzz',
//     },
//     // `${BASE_API_URL}provider/token-with-authorities`,
//     // {
//     //   headers: {
//     //     'Content-Type': 'application/json',
//     //     Authorization:
//     //       'Basic dGltQGJhc2Fsc21hcnRzb2x1dGlvbnMuY29tOlJpbmcjIzEyMzQ=',
//     //   },
//     //   auth: data,
//     // }

//     {
//       headers: {
//         'Content-Type': 'application/json',
//         // Authorization:
//         //   'Basic dGltQGJhc2Fsc21hcnRzb2x1dGlvbnMuY29tOlJpbmcjIzEyMzQ=',
//       },
//       // auth: {
//       //   password: 'password',
//       //   username: 'siphuzz',
//       // },
//       proxy: {
//         protocol: 'http',
//         host: '35.224.7.3',
//         port: 8081,
//         // auth: data,
//         auth: {
//           password: 'password',
//           username: 'siphuzz',
//         },
//       },
//     }
//   );
//   return response;
// };

export const loginStepOne = async (data) => {
  const {
    authReducer: { location },
  } = store.getState();

  const savedDomain = typeof window !== 'undefined' ? window.localStorage?.getItem('SWITCH_SERVER_DOMAIN') : null;
  const base = (location || savedDomain || BASE_API_URL || '').replace(/\/+$/, '');

  const response = await axios.get(
    `${base}/provider/token-with-authorities`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Basic cmluZ2VyZGV2M0BnbWFpbC5jb206cmluZ2VyZGV2MjAyMw==',
      },
      auth: data,
    }
  );
  return response;
};
export const loginStepTwo = async () => {
  const response = await axiosPost('users/api/login', {});
  return response;
};
